function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 31.993,
  cy: 31.993,
  r: 31.295,
  fill: "#E2F4EF",
  stroke: "#19A784",
  strokeWidth: 1.397,
  transform: "translate(2 2)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#19A784",
  transform: "translate(43.78 42.123)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11.705,
  cy: 11.705,
  r: 11.705,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19A784",
  fillRule: "nonzero",
  strokeWidth: 0.5,
  d: "M18.972 6.46c-.3-.29-.783-.29-1.082 0L8.73 15.371l-3.522-3.425c-.299-.29-.783-.29-1.081 0-.3.29-.3.761 0 1.052l4.062 3.951c.298.29.783.29 1.081 0l9.703-9.437c.298-.29.298-.761 0-1.052z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#19A784",
  strokeWidth: 1.17,
  d: "M19.147 23.547c-.041 6.437-1.15 12.426-4.522 17.83-.814 1.303-1.798 2.508-2.766 3.709-.635.789-.997 1.576-.523 2.55.455.936 1.25 1.21 2.26 1.168 5.244-.222 10.394.454 15.48 1.672 1.107.265 1.963.003 2.687-.918 4.351-5.54 7.047-11.766 8.099-18.698.738-4.87.7-9.727-.186-14.572-.286-1.563-1.8-2.274-3.174-1.47-2.805 1.643-5.79 2.809-9.04 3.097-1.942.172-3.917.134-5.865.011-1.61-.101-2.664.701-2.608 2.31.04 1.167.11 2.333.158 3.311"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19A784",
  d: "M33.553 48.623c3.127-2.533 5.67-5.576 7.805-8.947 3.241-5.117 5.49-10.62 6.608-16.551.1-.536.188-1.078.215-1.62.06-1.193-.82-2.183-2.009-2.142-1.69.058-3.376.23-5.14.358l.172 1.296c1.368-.119 2.709-.216 4.044-.355 1.416-.148 1.684.055 1.518 1.443-.451 3.767-1.722 7.305-3.265 10.755-1.752 3.916-4.042 7.505-6.752 10.866-1.22 1.512-2.14 3.258-3.196 4.897"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#19A784",
  d: "M36.59 48.623c1.247-.92 2.54-1.783 3.735-2.768 6.217-5.13 10.438-11.602 12.589-19.436.14-.512.194-1.1.098-1.616-.172-.932-.998-1.56-1.917-1.54-.592.014-1.181.135-1.78.208l-.273 1.327c.528-.06.976-.124 1.427-.163 1.238-.106 1.603.261 1.183 1.44-.843 2.37-1.649 4.771-2.732 7.031-1.977 4.125-4.824 7.606-8.16 10.711-1.538 1.431-2.86 3.1-4.28 4.66l.11.146"
}));

function SvgCardboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardboard);
export default __webpack_public_path__ + "static/media/cardboard.930d1b7e.svg";
export { ForwardRef as ReactComponent };